import React, { useState, useEffect } from 'react';
import { createProfile, getTemplates } from '../utils/api';

const DAYS_OF_WEEK = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

export default function ProfileForm({ onCreated, editDashboard }) {
  const [form, setForm] = useState({ name: '', industry: '', role: '', interests: '', context: '', schedule: 'daily' });
  const [email, setEmail] = useState({ enabled: false, email: '', schedule: 'daily', dayOfWeek: 1, dayOfMonth: 1, templateId: 'default' });
  const [templates, setTemplates] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getTemplates().then(setTemplates).catch(console.error);
    if (editDashboard) {
      setForm({ name: editDashboard.name, industry: editDashboard.industry, role: editDashboard.role, interests: editDashboard.interests, context: editDashboard.context || '', schedule: editDashboard.schedule || 'custom' });
      if (editDashboard.emailConfig) setEmail({ ...email, ...editDashboard.emailConfig });
    }
  }, [editDashboard]);

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const payload = { ...form, schedule: form.schedule, emailConfig: email.enabled ? email : { enabled: false } };
      if (editDashboard) payload.dashboardId = editDashboard.dashboardId;
      const res = await createProfile(payload);
      onCreated(res.dashboardId);
      if (!editDashboard) {
        setForm({ name: '', industry: '', role: '', interests: '', context: '' });
        setEmail({ enabled: false, email: '', schedule: 'daily', dayOfWeek: 1, dayOfMonth: 1, templateId: 'default' });
      }
    } catch (err) { alert(err.message); }
    setLoading(false);
  };

  const inputStyle = { width: '100%', padding: 8, marginBottom: 8, boxSizing: 'border-box', border: '1px solid #ccc', borderRadius: 4 };
  const selectStyle = { ...inputStyle, background: '#fff' };

  return (
    <form onSubmit={submit} style={{ background: '#f9f9f9', padding: 16, borderRadius: 8, marginBottom: 16 }}>
      <h3 style={{ marginTop: 0 }}>{editDashboard ? 'Edit Dashboard' : 'New Dashboard Profile'}</h3>
      <input placeholder="Dashboard name (e.g. Gaming Customers)" value={form.name} onChange={set('name')} style={inputStyle} required />
      <input placeholder="Industry (e.g. Games, FinTech, Healthcare)" value={form.industry} onChange={set('industry')} style={inputStyle} required />
      <input placeholder="Target role (e.g. CTO, DevOps Engineer)" value={form.role} onChange={set('role')} style={inputStyle} required />
      <input placeholder="Key interests (e.g. compute, AI/ML, serverless)" value={form.interests} onChange={set('interests')} style={inputStyle} required />
      <textarea placeholder="Additional context (optional)" value={form.context} onChange={set('context')} style={{ ...inputStyle, minHeight: 60 }} />

      <div style={{ marginBottom: 12 }}>
        <label style={{ fontWeight: 500, fontSize: 14, marginBottom: 4, display: 'block' }}>Schedule</label>
        <select value={form.schedule || 'custom'} onChange={(e) => setForm({ ...form, schedule: e.target.value })} style={selectStyle}>
          <option value="daily">Daily (auto-curate last 24h)</option>
          <option value="weekly">Weekly (auto-curate last 7 days)</option>
          <option value="monthly">Monthly (auto-curate last 30 days)</option>
          <option value="custom">Custom (one-time, pick dates)</option>
        </select>
      </div>

      <div style={{ border: '1px solid #ddd', borderRadius: 4, padding: 12, marginBottom: 12, background: '#fff' }}>
        <label style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer', fontWeight: 500, marginBottom: email.enabled ? 12 : 0 }}>
          <input type="checkbox" checked={email.enabled} onChange={(e) => setEmail({ ...email, enabled: e.target.checked })} />
          📧 Enable email notifications
        </label>
        {email.enabled && (
          <>
            <input type="email" placeholder="Recipient email" value={email.email} onChange={(e) => setEmail({ ...email, email: e.target.value })} style={inputStyle} required />
            <div style={{ display: 'flex', gap: 8, marginBottom: 8 }}>
              <select value={email.schedule} onChange={(e) => setEmail({ ...email, schedule: e.target.value })} style={{ ...selectStyle, flex: 1 }}>
                <option value="daily">Daily</option>
                <option value="weekly">Weekly</option>
                <option value="monthly">Monthly</option>
              </select>
              {email.schedule === 'weekly' && (
                <select value={email.dayOfWeek} onChange={(e) => setEmail({ ...email, dayOfWeek: parseInt(e.target.value) })} style={{ ...selectStyle, flex: 1 }}>
                  {DAYS_OF_WEEK.map((d, i) => <option key={i} value={i}>{d}</option>)}
                </select>
              )}
              {email.schedule === 'monthly' && (
                <select value={email.dayOfMonth} onChange={(e) => setEmail({ ...email, dayOfMonth: parseInt(e.target.value) })} style={{ ...selectStyle, flex: 1 }}>
                  {Array.from({ length: 28 }, (_, i) => <option key={i + 1} value={i + 1}>{i + 1}</option>)}
                </select>
              )}
            </div>
            <select value={email.templateId} onChange={(e) => setEmail({ ...email, templateId: e.target.value })} style={selectStyle}>
              {templates.map(t => <option key={t.SK || t.templateId} value={t.SK || t.templateId}>{t.name}</option>)}
              {templates.length === 0 && <option value="default">Default Digest</option>}
            </select>
          </>
        )}
      </div>

      <button type="submit" disabled={loading}
        style={{ padding: '8px 24px', background: '#0073bb', color: '#fff', border: 'none', borderRadius: 4, cursor: 'pointer' }}>
        {loading ? 'Saving...' : editDashboard ? 'Save Changes' : 'Create Dashboard'}
      </button>
    </form>
  );
}
